/** Creates a tiny local video for the query-gated browser smoke test. */
export async function createChromaTestVideo(): Promise<File> {
  const canvas = document.createElement('canvas');
  canvas.width = 320;
  canvas.height = 180;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Self-test canvas is unavailable.');

  const stream = canvas.captureStream(10);
  const preferredType = 'video/webm;codecs=vp8';
  const mimeType = MediaRecorder.isTypeSupported(preferredType) ? preferredType : 'video/webm';
  const recorder = new MediaRecorder(stream, { mimeType });
  const chunks: Blob[] = [];
  recorder.addEventListener('dataavailable', (event) => {
    if (event.data.size) chunks.push(event.data);
  });

  const completed = new Promise<File>((resolve, reject) => {
    recorder.addEventListener('error', () => reject(new Error('Could not record the self-test video.')));
    recorder.addEventListener('stop', () => {
      stream.getTracks().forEach((track) => track.stop());
      resolve(new File(chunks, 'limonade-eye-self-test.webm', { type: 'video/webm' }));
    });
  });

  let frame = 0;
  const markerPositions = [
    [22, 20], [100, 22], [218, 20], [298, 22],
    [22, 158], [102, 156], [220, 158], [298, 156],
    [160, 90],
  ] as const;
  const drawFrame = (): void => {
    context.fillStyle = frame < 10 ? '#18b83c' : '#159b36';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#111611';
    markerPositions.forEach(([x, y]) => {
      context.beginPath();
      context.arc(x, y, 5, 0, Math.PI * 2);
      context.fill();
    });
    context.fillStyle = '#063b13';
    context.fillRect((frame * 11) % 250, 55, 70, 70);
    frame++;
  };

  drawFrame();
  recorder.start(100);
  const timer = window.setInterval(() => {
    drawFrame();
    if (frame >= 20) {
      window.clearInterval(timer);
      recorder.stop();
    }
  }, 100);

  return completed;
}

export async function installChromaSelfTest(input: HTMLInputElement): Promise<void> {
  const file = await createChromaTestVideo();
  const transfer = new DataTransfer();
  transfer.items.add(file);
  input.files = transfer.files;
  input.dispatchEvent(new Event('change', { bubbles: true }));
}
